/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Quick_ActionsInputs */

const en_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Actions`)
};

const de_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnelle Aktionen`)
};

const fr_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions rapides`)
};

const es_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones rápidas`)
};

const it_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni Rapide`)
};

const nl_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelle Acties`)
};

const pl_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybkie akcje`)
};

const fi_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pikatoiminnot`)
};

const da_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hurtige handlinger`)
};

const sv_dashboard_quick_actions = /** @type {(inputs: Dashboard_Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snabba Åtgärder`)
};

/**
* | output |
* | --- |
* | "Quick Actions" |
*
* @param {Dashboard_Quick_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_quick_actions = /** @type {((inputs?: Dashboard_Quick_ActionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Quick_ActionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_quick_actions(inputs)
	if (locale === "fr") return fr_dashboard_quick_actions(inputs)
	if (locale === "es") return es_dashboard_quick_actions(inputs)
	if (locale === "it") return it_dashboard_quick_actions(inputs)
	if (locale === "nl") return nl_dashboard_quick_actions(inputs)
	if (locale === "pl") return pl_dashboard_quick_actions(inputs)
	if (locale === "fi") return fi_dashboard_quick_actions(inputs)
	if (locale === "da") return da_dashboard_quick_actions(inputs)
	if (locale === "sv") return sv_dashboard_quick_actions(inputs)
	return en_dashboard_quick_actions(inputs)
});